import { render, staticRenderFns } from "./knightList.vue?vue&type=template&id=1d2e35be"
import script from "./knightList.vue?vue&type=script&lang=ts"
export * from "./knightList.vue?vue&type=script&lang=ts"
import style0 from "./knightList.vue?vue&type=style&index=0&id=1d2e35be&prod&lang=stylus&module=true"
import style1 from "./knightList.vue?vue&type=style&index=1&id=1d2e35be&prod&lang=less"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports